<template>
  <div class="toolTip-container">
      <div :class="'inner tooltip_' + type " >
        <i :class="'icon iconfont '+ iconMap[type]"></i>
        {{msg}}
      </div>
  </div>
</template>
<script>
const iconMap = {
	error: "icon-failed",
	warning: "icon-jinggao",
	success: "icon-chenggong",
	info: "icon-FontAwesomeinfocircle",
};
export default {
  name: "ToolTip",
  data() {
    return {
      iconMap,
    }
  },
	props: {
		type: {
			type: String,
			default: "success",
		},
		options: [String, Object],
	},
	computed: {
		msg() {
      return this.options.msg;
    }
	},

};
</script>
<style scoped>
.toolTip-container {
	position: fixed;
	z-index: 999999;
	top: 10vh;
	left: 0;
	right: 0;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	color: rgba(0, 0, 0, 0.85);
	font-size: 1.4rem;
	font-variant: tabular-nums;
	line-height: 1.5715;
	list-style: none;
	font-feature-settings: "tnum";
	width: 100%;
	pointer-events: none;
	text-align: center;
}
.inner {
	display: inline-block;
	padding: 1rem 1.6rem;
	background: #fff;
	border-radius: 5px;
	-webkit-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
		0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
	box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
		0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
	pointer-events: all;
}

.tooltip_info .icon{
  color: #2145DB;
}
.tooltip_error .icon{
  color: #FF3B30;
}
.tooltip_success .icon{
  color: #80ee67;
}
.tooltip_warning .icon{
  color: #FFBF00;
}
</style>